
import $ from 'jquery';
import { Component, Vue } from 'vue-property-decorator';
import { TeMeasurement } from '../../backend/backendapi';
import TeMeasurementRowSeparateTesterEditor from './TeMeasurementRowSeparateTesterEditor.vue';

@Component({
  components: {
    TeMeasurementRowSeparateTesterEditor,
  },
})
export default class TeMeasurementRowSeparateTesterEditModal extends Vue {
  measurement: TeMeasurement | null = null;

  public open(measurement: TeMeasurement): void {
    this.measurement = measurement;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
    this.measurement = null;
  }
}
